import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { playClickSound } from '../utils/sounds';

function LoginButton() {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = () => {
    playClickSound();
    loginWithRedirect();
  };

  return (
    <button
      onClick={handleLogin}
      className="menu-btn secondary auth-btn"
    >
      Log In
    </button>
  );
}

export default LoginButton;
